import script from "./material-request.vue?vue&type=script&lang=ts&setup=true"
export * from "./material-request.vue?vue&type=script&lang=ts&setup=true"

import "./material-request.vue?vue&type=style&index=0&id=8b99a8fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b99a8fc"]])

export default __exports__